import React from "react";
import PropTypes from "prop-types";
import { v4 as uuid } from "uuid";

import { IPagination } from "../interfaces/IUtils";
import {
  APP_MAX_PAGES_PAGINATION,
  APP_PAGINATION_PAGES_VARIATION,
} from "../config/appConfig";

function getPaginationLink(pageNumber, onClick, isActive = false) {
  return (
    <li className={`page-item ${isActive ? "active" : ""} `} key={uuid()}>
      <a
        className="page-link"
        href="#!"
        onClick={() => {
          onClick(pageNumber);
        }}
      >
        {pageNumber}
      </a>
    </li>
  );
}

function getAllLinks(numberOfLinks, onClickFN, currentPage) {
  const response = [];
  for (let index = 0; index < numberOfLinks; index++) {
    const pageNumber = index + 1;
    response.push(
      getPaginationLink(pageNumber, onClickFN, pageNumber === currentPage)
    );
  }
  return response;
}

function getCalculatedLinks(pagination: IPagination, onClickFN) {
  const response = [];
  const maxNumberOfPages = APP_MAX_PAGES_PAGINATION - 2;

  // const minPageOfCurrent = pagination.currentPage - APP_PAGINATION_PAGES_VARIATION
  // const maxPageOfCurrent = pagination.currentPage + APP_PAGINATION_PAGES_VARIATION

  // Agregar pagina 1
  response.push(getPaginationLink(1, onClickFN, pagination.currentPage === 1));

  for (let index = 0; index < maxNumberOfPages; index++) {
    const pageNumber = index + 2;
    response.push(
      getPaginationLink(
        pageNumber,
        onClickFN,
        pagination.currentPage === pageNumber
      )
    );
  }

  // Agregar pagina final
  response.push(
    getPaginationLink(
      pagination.pages,
      onClickFN,
      pagination.currentPage === pagination.pages
    )
  );

  return response;
}

function getPaginationFromProps(props): IPagination {
  let pagination: IPagination = {
    currentPage: 1,
    from: 0,
    count: 15,
    total: 0,
    pages: 1,
  };

  if (props.pagination && props.pagination.currentPage) {
    pagination = props.pagination;
  }

  return pagination;
}

function paginationBar(props) {
  const pagination = getPaginationFromProps(props);
  const onPageClickFN = (pageNumber: number) => {
    if (pageNumber !== pagination.currentPage) {
      props.onPageClick(pageNumber);
    }
  };
  const onPreviusPageClick = () => {
    const newPageNumber = pagination.currentPage - 1;
    if (newPageNumber <= 0) return;

    onPageClickFN(newPageNumber);
  };
  const onNextPageClick = () => {
    const newPageNumber = pagination.currentPage + 1;
    if (newPageNumber > pagination.pages) return;

    onPageClickFN(newPageNumber);
  };

  //   if (pagination.pages <= 1) return <></>;

  let linkElements = [];
  if (pagination.pages <= APP_MAX_PAGES_PAGINATION) {
    linkElements = getAllLinks(
      pagination.pages,
      onPageClickFN,
      pagination.currentPage
    );
  } else {
    linkElements = getCalculatedLinks(pagination, onPageClickFN);
  }

  return (
    <ul className="pagination">
      <li className="page-item">
        <a className="page-link" href="#!" onClick={onPreviusPageClick}>
          <span aria-hidden="true">«</span>
        </a>
      </li>
      {linkElements}
      <li className="page-item">
        <a className="page-link" href="#!" onClick={onNextPageClick}>
          <span aria-hidden="true">»</span>
        </a>
      </li>
    </ul>
  );
}

paginationBar.propTypes = {
  pagination: PropTypes.object.isRequired,
  onPageClick: PropTypes.func.isRequired,
};

export default paginationBar;
